import * as React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
`

const Item = styled.div`
  align-items: center;
  display: flex;
  font-size: 0.8rem;
  font-weight: 600;
  gap: 0.4rem;
  line-height: 1.1;
  opacity: 0.6;

  &:not(:first-child):before {
    content: '/';
    opacity: 0.16;
  }
`

export interface NavigationDropdownTextListProps {
  items: Array<{ text: string }>
}

export const NavigationDropdownTextList = ({ items }: NavigationDropdownTextListProps) => {
  return (
    <Wrapper>
      {items.map(item => (
        <Item key={item.text}>{item.text}</Item>
      ))}
    </Wrapper>
  )
}
